export default {
    namespaced: true,
    state: {
        caseShapes: [],
        errors: {
            getCaseShapes: {}
        }
    },
    mutations: {
        SET_CASE_SHAPES(state, payload) {
            state.caseShapes = payload
        },
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        }
    },
    actions: {
        async getCaseShapes({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'getCaseShapes',
                val: {}
            })

            const url = '/public/dict/case-shapes'

            try {
                const resp = await this.$axios
                    .get(url, {
                        params: data
                    })
                    .then(res => {
                        return res.data
                    })

                commit('SET_CASE_SHAPES', resp)
            } catch (e) {
                if (e.response && e.response.data) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getCaseShapes',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getCaseShapes',
                        val: { error: 'Ошибка' }
                    })
                }
            }
        }
    }
}
